module.exports = __webpack_public_path__ + "png/bg-white-pattern-full.png";